const observe = {
    classChange(el, className, callback) {
        let active = el.classList.contains(className);

        new MutationObserver(() => {
            const now = el.classList.contains(className);

            if (now !== active) {
                active = now;
                callback(now);
            }
        }).observe(el, { attributes: true, attributeFilter: ['class'] });
    },
};

export default observe;
